import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'
import { useLoadingSpinnerContext } from '../context/loadingSpinnerContext';

function LoadingSpinnerGlobal() {
  const { globalLoading } = useLoadingSpinnerContext();
  return globalLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: 9999 }}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : null
}
export default LoadingSpinnerGlobal
